export type AddressQueryProps = {
  address: string;
  city: string;
  province: string;
  zip: string;
  beds?: number;
  baths?: number;
  propertyType?: string[] | string;
  yearBuilt?: number;
  minYearBuilt?: number;
  maxYearBuilt?: number;
  geoLocation?: string;
  // filter Params
  minPrice?: number;
  maxPrice?: number;
  minBeds?: number;
  maxBeds?: number;
  minBaths?: number;
  maxBaths?: number;
  searchRadius?: number;
  dateRange?: number;
};

export interface DatafinitiExtraInfo {
  year?: string;
  sqft?: string;
  lot?: string;
  datafinitiId?: string;
  beds?: number;
  baths?: number;
  images?: string[];
  geoLocation?: string; // "POINT (lat:number, long: number)""
}
